import { array, number, object, string } from 'idonttrustlikethat'

const fileUpload = array(
  object({
    id: number,
    name: string,
    alternativeText: string.nullable(),
    caption: string.nullable(),
    width: number.nullable(),
    height: number.nullable(),
    formats: string.nullable(),
    hash: string,
    ext: string.nullable(),
    mime: string.nullable(),
    size: number,
    url: string.nullable(),
    previewUrl: string.nullable(),
    provider: string,
    provider_metadata: string.nullable(),
    createdAt: string,
    updatedAt: string,
    documentId: string,
    publishedAt: string
  })
)

type FileUpload = typeof fileUpload.T

export { fileUpload }

export type { FileUpload }
